export function searchAlertInit() {
	const searchAlertButton = document.getElementById('search-alert');
	const searchForm = document.getElementById('apartment-search-form');

	if (!searchAlertButton) {
		return;
	}

	// Helper function to get current search criteria from form or URL
	function getCurrentSearchCriteria() {
		// If form exists, get values from form
		if (searchForm) {
			const formData = new FormData(searchForm);
			return {
				keywords: formData.getAll('keywords[]'),
				rooms: formData.getAll('rooms[]'),
				area_from: formData.get('area_from') || '',
				area_to: formData.get('area_to') || '',
				rent_to: formData.get('rent_to') || '',
				services: formData.getAll('services[]'),
				sort: formData.get('sort') || '',
				is_vacant: formData.get('is_vacant') || ''
			};
		}

		// Fallback to URL parameters
		const urlParams = new URLSearchParams(window.location.search);
		return {
			keywords: urlParams.getAll('keywords[]'),
			rooms: urlParams.getAll('rooms[]'),
			area_from: urlParams.get('area_from') || '',
			area_to: urlParams.get('area_to') || '',
			rent_to: urlParams.get('rent_to') || '',
			services: urlParams.getAll('services[]'),
			sort: urlParams.get('sort') || '',
			is_vacant: urlParams.get('is_vacant') || ''
		};
	}

	// Remove previous event listeners stored on the element
	if (searchAlertButton._clickHandler) {
		searchAlertButton.removeEventListener('click', searchAlertButton._clickHandler);
	}
	if (searchAlertButton._submitHandler && searchForm) {
		searchForm.removeEventListener('submit', searchAlertButton._submitHandler);
	}

	// Store handlers on the element to avoid module-level state in the global scope
	searchAlertButton._clickHandler = (e) => {
		e.preventDefault();

		const searchCriteria = getCurrentSearchCriteria();

		// Store in sessionStorage
		sessionStorage.setItem('hakuvahtiSearchCriteria', JSON.stringify(searchCriteria));

		// Redirect to hakuvahti page
		window.location.href = searchAlertButton.getAttribute('href');
	};

	searchAlertButton._submitHandler = (e) => {
		const searchCriteria = getCurrentSearchCriteria();
		sessionStorage.setItem('hakuvahtiSearchCriteria', JSON.stringify(searchCriteria));
	};

	// Save search criteria when "Set up search alert" button is clicked
	searchAlertButton.addEventListener('click', searchAlertButton._clickHandler);

	// Save search criteria when form is submitted
	if (searchForm) {
		searchForm.addEventListener('submit', searchAlertButton._submitHandler);
	}
}

// Expose to window for non-module scripts
if (typeof window !== 'undefined') {
	window.searchAlertInit = searchAlertInit;
}
